export default "__VITE_ASSET__MvYpdGoc__"